import { defineAsyncComponent } from '../compat/vueCompat';
import type { FolderMoveWaitDialogRequest } from './folderMoveWaitDialogRequest';
import { createReactiveDialogRequest, requestDialog } from './requestDialog';

const MoveFolderContentDialog = defineAsyncComponent(() => import('@mimir/web/components/Common/Dialogs/dialogs/MoveFolderContentDialog.vue'));

export function showFolderMoveWaitDialog() {
  const req = createReactiveDialogRequest<FolderMoveWaitDialogRequest>({
    movementRequests: [],
  });
  requestDialog(req, MoveFolderContentDialog);
  return req;
}
